function toggleCampos(desabilitado = false, campos = []) {
    for (let campo of campos) {
        document.querySelector(
            `input[name="${campo}"], select[name="${campo}"]`
        ).disabled = desabilitado;
    }
}

function alterarCampos(valores = {}) {
    for (let [campo, valor] of Object.entries(valores)) {
        document.querySelector(`input[name="${campo}"], select[name="${campo}"]`).value = valor;
    }
}

export { toggleCampos, alterarCampos }